<template>
    <div id="aroundDetail">
        <top :title="title"></top>
        <div class="setFix"></div>
        <div class="aroundWrap">
            <div class="item-list">
                <p class="name">{{detail.name}}</p>
                <p class="address">{{(disc<1000)?disc:((disc)/1000).toFixed(1)}}米丨{{detail.address}}</p>
                <div class="btm clearfix">
                    <div class="left" @click="gowhere(detail.location)">
                        去这里
                    </div>
                    <div class="right" @click="call(detail.tel)" :class="detail.tel.length==0?'notel':''">
                        电话
                    </div>
                </div>
            </div>
            <div class="line5"></div>
            <div class="imgBox" v-show="photo.length!=0">
                <img 
                    preview="1"
                    v-show="index==0"
                    v-for="(url,index) in photo"
                    :src="url"
                    :key="index"
                    alt=""/>
                <span class="pic">{{len}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import Top from '@/component/top/top'
export default {
    data() {
        return {
            title:'',
            detail:{},
            photos:[],
            // photo:[],
            photo:[],
            len:0
        }
    },
    components:{
        Top
    },
    computed:{
        disc() {
            return this.$route.query.disc
        }
    },
    created() {
        this.title = this.$route.query.title
        this.getDetail()
    },
    beforeRouteLeave(to,from,next){
        let _preview = this.$preview.self;
        if (_preview !== null && _preview !== undefined) {
            _preview.close();
            _preview = null;
        }
        next()
    },
    methods:{
        getDetail() {
            axios.get(`https://restapi.amap.com/v3/place/detail?id=${this.$route.query.id}&output=json&key=${localStorage.getItem('key')}`).then((res) => {
                this.detail = res.data.pois[0]
                if(res.data.pois[0].photos.length!=0) {
                    this.photos = res.data.pois[0].photos[0]
                    res.data.pois[0].photos.forEach((item,index) => {
                        this.photo.push(item.url)
                    })
                    this.$previewRefresh()
                    this.len = res.data.pois[0].photos.length
                }
            })
        },
        gowhere(lon) {
            this.isScreen(`app://map?lng=${lon.split(',')[0]}&lat=${lon.split(',')[1]}`)
        },
        call(tel) {
            if(tel.length!=0) {
                this.isScreen(`app://tel?mobile=${tel}`)
            }
        },
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
.pswp {
      z-index: 10000001;
  }
#aroundDetail{
    .item-list{
        border-top:1px solid #d8d8d8;
    }
    .imgBox{
        height:152px;
        margin:15px;
        background-repeat: no-repeat;
        background-size:cover;
        position: relative;
        overflow: hidden;
        background-position: center center;
        img{
            width: 100%;
        }
        .pic{
            position: absolute;
            left: 5px;
            bottom:5px;
            font-size:@ft12;
            background: url('~@/assets/imgs/pic.png')no-repeat 10px center rgba(0,0,0,.5);
            background-size:13px;
            color:#fff;
            border-radius:16px;
            display: inline-block;
            padding:5px 9px 5px 27px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/arounddetail/detail.vue